import { mapDTO } from '@twistezo/ts-dto-mapper'

import { authUserCurrentWorkspaceFromDTO } from 'features/user/api/authUser'

import type { UserSlice, UserSliceDTO, Variables, VariablesDTO } from './types'

export const fromDTO = (from: UserSliceDTO): UserSlice =>
  mapDTO<UserSliceDTO, UserSlice>({ from }).transform(
    (dto: UserSliceDTO): UserSlice => ({
      currentWorkspace: dto.currentWorkspace
        ? authUserCurrentWorkspaceFromDTO(dto.currentWorkspace)
        : undefined,
      currentWorkspaceRole: dto.currentWorkspaceRole || undefined,
      id: dto.id,
      workspaceProducts: dto.workspaceProducts || undefined,
    }),
  )

export const toDTO = (from: Variables): VariablesDTO =>
  mapDTO<Variables, VariablesDTO>({ from }).transform(
    (variables: Variables): VariablesDTO => ({
      currentWorkspaceId: variables.currentWorkspaceId || null,
      id: variables.id,
    }),
  )
